import { css } from 'wiloke-react-core';

export const modalBody = css`
  max-width: 1400px;
  width: calc(100% - 60px);
  height: calc(100% - 300px);
  margin: 30px 50px;
  min-height: 620px;
`;
